import React from 'react';
import { Navbar } from '../components/Navbar';
import { CertificationPage } from '../components/CertificationPage';
import { Footer } from '../components/Footer';
export const Certification = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2337">
      <Navbar data-id="element-2338" />
      <CertificationPage data-id="element-2339" />
      <Footer data-id="element-2340" />
    </div>;
};